<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <router-link class="section" to="/saae-payments-imports">
                Importações SAAE
              </router-link>
              <i class="right chevron icon divider"></i>
              <div class="active section">{{ filename }}</div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div v-show="loading" class="ui active inverted dimmer">
          <div class="ui text loader">Carregando...</div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <table v-if="lines.length" class="ui small celled table">
              <tbody>
                <tr v-for="(line, index) in lines" :key="index" :class="lineClass(line)">
                  <td>{{ line }}</td>
                </tr>
              </tbody>
            </table>
            <div v-else-if="!loading" class="ui info message">
              Nenhum registro no log desta importação.
            </div>
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      filename: '',
      lines: []
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.loading = true;
      Api.saaePaymentsImports
        .fetch(this.$route.params.id)
        .then(response => {
          const data = response.data;
          this.filename = data.filename;
          this.lines = (data.log || '').split('\n').filter(l => l.trim());
        })
        .catch(error => {
          this.$toast.show('Erro ao carregar log', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    lineClass(line) {
      if (line.startsWith('[BAIXADO]')) return 'positive';
      if (line.startsWith('[JÁ PAGO]')) return 'warning';
      if (line.startsWith('[ERRO]')) return 'negative';
      if (line.startsWith('[NÃO ENCONTRADO]')) return 'negative';
      return '';
    }
  }
};
</script>
